<template lang="pug">
    div  
        .card-body.bg-light
            .form-row
                .col-md-5
                    label Razon Social
                    input.form-control.form-control-sm(v-model="parameter.BusinessName", @keypress.enter="sendSearch()")
                .col-md-2
                    label Rut
                    input.form-control.form-control-sm(v-model="parameter.RUT", @keypress.enter="sendSearch()")
                .col-md-3
                    label Estado
                    select.form-control.form-control-sm(v-model="parameter.Active" )
                        option(value=1) Activa
                        option(value=0) Inactiva
                        option(value=2) Todos
                .col-md-2
                    label 
                    button.btn.btn-primary.text-light.btn-block(@click="sendSearch()") Buscar 
                        i.fa.fa-search  
        .card-body.bg-light    
            .form-group.table-responsive
                    table.table.table-sm.table-borderedonlytable
                        thead.bg-table.text-white
                            th Editar
                            th Rut
                            th Razon Social                        
                            th Giro
                            th Direccion
                            th Estado  
                            th Movil Android
                            th Build Android     
                            th Movil IOS
                            th Build IOS                  
                        tbody.bg-white(name="table-fade", is="transition-group") 
                            tr(v-if="",v-bind:key="index" v-for="(item,index) in tablaInfo")
                                td
                                    button.btn.btn-sm.btn-info(@click="sendInfo(item)")  
                                        i.fa.fa-edit        
                                td {{item.RUT}}
                                td {{item.BusinessName}}
                                td {{item.ActivityEnterprises}}
                                td {{item.Adress}}
                                td {{item.Active==1 ? 'Activo':'Inactivo'}}
                                td {{item.APP_ANDROID_ACTIVE==1 ? 'Activo':'Inactivo'}}
                                td {{item.APP_ANDROID_BUILD}}
                                td {{item.APP_IOS_ACTIVE==1 ? 'Activo':'Inactivo'}}
                                td {{item.APP_IOS_BUILD}}

</template>
<script> 
export default {
    props:{
        tablaInfo:Array,
        parameter:Object
    }, 
    methods:{ 
            sendSearch(){ 
                this.$emit("update:parameter",this.parameter) 
                this.$emit("sendSearch",this.parameter) 
            },
            sendInfo(item){  
                this.$emit("sendInfo", Object.assign({}, item)) 
            }
    }
}
</script>
<style>
    .table-fade-enter-active {
      transition: all .5s ease;
    }
    .table-fade-leave-active {
      transition: all .5s ease;
    }
    .table-fade-enter, .table-fade-leave-to{
      transform: translateY(-20px);
      opacity: 0;
    } 
</style>